<template>
  <div>
    <div class="container-fluid">
      <div class="form-container">
        <form method="POST" class="form py-4 col-lg-4 col-md-7 col-sm-9 col-11 mx-auto">
          <h4 class="text-center mt-4 mb-2 form-heading">Confirm your phone number</h4>
          <p
            class="errors mb-4 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="errors"
          ></p>

          <p
            class="success mb-4 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="success"
            v-show="success"
          >Enter the the code sent to {{phoneNumber}} by Bookinga app</p>
          <p class="text-center m-0">If you've entered wrong phone number</p>
          <div class="text-center mb-3">
            <a
              class="show-modal text-center edit-phone"
              data-toggle="modal"
              data-target="#myModal"
              @click="editPhone"
            >Click here to Edit</a>
          </div>
          <!-- editPhoneNumber modal -->
          <div v-if="modalShow" class="modal fade" id="myModal">
            <div class="modal-dialog modal-dialog-centered myModal-md">
              <div class="modal-content">
                <div class="modal-body">
                  <form method="post" class="form">
                    <h5 class="text-primary myModal-heading">Edit Phone number</h5>
                    <p class="errors mx-auto my-2" id="errorm" v-show="errorsm"></p>
                    <p class="success mx-auto my-2" id="successm" v-show="successm"></p>
                    <div class="form-group mx-auto">
                      <label class="form-labe" for="phoneCodes">Phone number</label>
                      <br />
                      <span class="f-small">*Remember to include phone country code*</span>

                      <input
                        type="text"
                        class="form-control mt-0"
                        placeholder="Phone number"
                        name="phone"
                        id="phone"
                        v-model="NumberToEdit"
                        required
                      />
                    </div>
                    <div class="d-flex mt-3">
                      <div class="text-center mr-2">
                        <button
                          type="button"
                          class="btn modal-close-btn modal-close-btn-1"
                          data-dismiss="modal"
                        >Cancel</button>
                      </div>
                      <div class="text-center">
                        <button
                          type="submit"
                          @click.prevent="sendCode()"
                          class="btn btn-primary modal-close-btn modal-close-btn-2"
                          :data-dismiss="modalClose"
                        >
                          Send Code
                          <span
                            v-if="hasSubmittedm"
                            class="spinner-border spinner-border-sm ml-2 my-auto"
                          ></span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="number"
              class="form-control"
              placeholder="Enter verification code"
              name="codeSent"
              id="codeSent"
              v-model="codeSent"
              required
            />

            <!-- <label class="form-label" for="codeSent">Enter verification code</label> -->
          </div>

          <p class="text-center mb-1">Did not receive the code ?</p>
          <div class="text-center my-2">
            <a
              name="resendCode"
              id="resendCode"
              v-if="NotResending"
              class="resendCode"
              href="#"
              @click="resendCode()"
              role="button"
            >Click here to resend</a>
            <p class="text-center text-primary" v-if="resending">Resending verification code ....</p>
          </div>
          <div class="text-center mb-3">
            <button
              type="submit"
              class="btn btn_styles btn-md btn-primary"
              @click.prevent="verify()"
            >
              Verify
              <span v-if="hasSubmitted" class="spinner-border spinner-border-sm ml-2 my-auto"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://bookinga.herokuapp.com/api/v1/client/phoneVerification";
const resendCodeUrl = "https://bookinga.herokuapp.com/api/v1/client/resendCode";
const sendCodeUrl =
  "https://bookinga.herokuapp.com/api/v1/client/forgotpassword";
import axios from "axios";
import CryptoJS from "crypto-js";
import router from "./../../router/index";
import { func } from "joi";
export default {
  data() {
    return {
      errors: false,
      success: true,
      modalShow: true,
      errorsm: false,
      successm: false,
      codeSent: "",
      hasSubmitted: false,
      hasSubmittedm: false,
      resending: false,
      phoneNumber: "",
      NotResending: true
    };
  },
  created() {
    let verificationTokenObject = this.$route.query;
    let verificationToken = verificationTokenObject.txyz04eg.trim();
    verificationToken = verificationToken.replace(/ /g, "+");
    var decryptedBytes = CryptoJS.AES.decrypt(
      verificationToken,
      "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
    );
    this.phoneNumber = decryptedBytes.toString(CryptoJS.enc.Utf8);
  },
  methods: {
    resendCode() {
      this.resending = true;
      this.NotResending = false;
      axios
        .post(resendCodeUrl, { Telephone: this.phoneNumber })
        .then(response => {
          if (response.data.success == true) {
            this.resending = false;
            return (this.NotResending = true);
          } else {
            this.resending = false;
            this.NotResending = true;
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail:
                "An error occured while trying to resend verification code! Try again",
              group: "br",
              life: 3000
            });
          }
        })
        .catch(function(error) {
          this.resending = false;
          return (this.NotResending = true);
        });
    },
    sendCode() {
      if (this.NumberToEdit.length < 1) {
        this.errorsm = true;
        document.getElementById("errorm").innerHTML =
          "Please! Enter your account phone number";
      } else if (this.NumberToEdit == this.phoneNumber) {
        this.errorsm = true;
        document.getElementById("errorm").innerHTML =
          "You didn't edit the Phone number! Edit or Cancel this modal";
      } else {
        this.hasSubmittedm = true;
        axios
          .post(sendCodeUrl, {
            Telephone: this.NumberToEdit
          })
          .then(response => {
            if (response.data.success == true) {
              this.errorsm = false;
              this.hasSubmittedm = false;
              this.phoneNumber = this.NumberToEdit;
              var encryptedAES = CryptoJS.AES.encrypt(
                this.NumberToEdit,
                "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
              );
              this.modalShow = false;
              return router.push("/resetByPhone/?txyz04eg=" + encryptedAES);
            } else {
              this.hasSubmittedm = false;
              this.errorsm = true;
              document.getElementById("errorm").innerHTML =
                response.data.message;
            }
          })
          .catch(error => {
            this.hasSubmittedm = false;
            this.errorsm = true;
            document.getElementById("errorm").innerHTML =
              "An error occured! Try again";
          });
      }
    },
    verify() {
      if (this.codeSent == "") {
        this.success = false;
        this.errors = true;
        document.getElementById("error").innerHTML =
          "Please! Enter 6 digits  code sent the number you provided";
      } else if (this.codeSent.length < 6) {
        this.success = false;
        this.errors = true;
        document.getElementById("error").innerHTML = "Invalid code Entered";
      } else {
        let verificationTokenObject = this.$route.query;
        let verificationToken = verificationTokenObject.txyz04eg.trim();
        verificationToken = verificationToken.replace(/ /g, "+");
        var decryptedBytes = CryptoJS.AES.decrypt(
          verificationToken,
          "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
        );
        var plaintext = decryptedBytes.toString(CryptoJS.enc.Utf8);
        this.hasSubmitted = true;
        axios
          .post(url, {
            phoneNumber: plaintext,
            code: this.codeSent
          })
          .then(response => {
            if (response.data.success == true) {
              localStorage.setItem("jwt", response.data.token);
              this.hasSubmitted = false;
              return router.push("/dashboard/bus");
            } else {
              this.hasSubmitted = false;
              this.success = false;
              this.errors = true;
              document.getElementById("error").innerHTML =
                "You've Entered wrong  code, check and try again";
            }
          })
          .catch(error => {
            this.hasSubmitted = false;
            this.success = false;
            this.errors = true;
            document.getElementById("error").innerHTML =
              "You've Entered wrong  code, check and try again";
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>